// extracted by mini-css-extract-plugin
module.exports = {"videoLibrary":"FoldersListClipsModal-modulevideoLibrary3ek","row":"FoldersListClipsModal-modulerow1ow","emptyStateContainer":"FoldersListClipsModal-moduleemptyStateContainer1XK"};